import Vue from "vue";
import Vuex from "vuex";
import userModule from "@/modules/user/store";
import adminModule from "@/modules/admin/store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userModule,
    admin: adminModule,
  },
  state() {
    return {
      showAlert: false,
      dataAlert: {},
    }
  },
  getters: {
    getShowAlert(state) {
      return state.showAlert
    },
    getDataAlert(state) {
      return state.dataAlert
    },
  },
  mutations: {
    setAlert(state, values) {
      state.showAlert = values
    },
    setDataAlert(state, values) {
      state.dataAlert = values
    },
  },
});
